/**
 * @param {Object} palette
 * @returns {Object}
 */
export const scrollbarStyle = palette => ({
  '&::-webkit-scrollbar': {
    width: 8,
    height: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: palette.grey[400],
    borderRadius: 4,
    border: `2px solid ${palette.grey[100]}`,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: palette.grey[500],
  },
});
